/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { GTMPasswordRecoveryCompletePayload } from '@/data/types/GTM';

export const getGTMPasswordRecoveryCompleteEventData = (
	_payload: GTMPasswordRecoveryCompletePayload
) => ({});
